import { useEffect, useState } from 'react';

export default function PrivacyHero() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [animated, setAnimated] = useState(false);
  const [kineticIndex, setKineticIndex] = useState(0);

  const backgroundImages = [
    "/images/privacy-bg-1.jpg",
    "/images/privacy-bg-2.jpg",
    "/images/privacy-bg-3.jpg",
    "/images/privacy-bg-4.jpg"
  ];

  const kineticWords = ['Secure', 'Encrypted', 'Protected'];

  useEffect(() => {
    setAnimated(true);

    const imageInterval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % backgroundImages.length);
    }, 5000);

    const kineticInterval = setInterval(() => {
      setKineticIndex((prev) => (prev + 1) % kineticWords.length);
    }, 2000);

    return () => {
      clearInterval(imageInterval);
      clearInterval(kineticInterval);
    };
  }, []);

  const features = [
    'AES-256 encryption in transit',
    'Processed in memory only',
    'Deleted immediately after generation',
    'Zero data retention',
    'No third-party access',
    'Nothing to subpoena',
  ];

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Slideshow */}
      <div className="absolute inset-0">
        {backgroundImages.map((img, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-[2000ms] ${
              currentImageIndex === index ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={img}
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
        ))}
        <div className="absolute inset-0 bg-gradient-to-b from-[#09090b]/40 via-[#09090b]/25 to-[#09090b]/60"></div>
      </div>

      <div className="relative z-10 w-full">
        <div className="max-w-[1400px] mx-auto px-6 sm:px-8 py-24 sm:py-32">
          <div className="max-w-[800px] mx-auto text-center space-y-6 sm:space-y-8">
            <h1
              className={`font-harvey-serif text-white text-[36px] sm:text-[52px] lg:text-[64px] font-normal leading-[1.05] tracking-tight transition-all duration-700 ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
            >
              HushLegal
            </h1>

            <p
              className={`font-harvey-sans text-[#d4d4d8] text-[18px] sm:text-[22px] leading-relaxed font-light tracking-wide transition-all duration-700 delay-200 ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              How We Protect Your Data — Your client information is privileged. We treat it that way
            </p>

            {/* Kinetic Text */}
            <div className="h-[50px] sm:h-[60px] overflow-hidden relative flex items-center justify-center">
              {kineticWords.map((word, index) => (
                <span
                  key={word}
                  className={`font-harvey-serif absolute text-[#06b6d4] text-[36px] sm:text-[48px] font-normal tracking-tight transition-all duration-500 ${
                    kineticIndex === index
                      ? 'opacity-100 translate-y-0 scale-100'
                      : 'opacity-0 translate-y-8 scale-95'
                  }`}
                  style={{
                    textShadow: '0 0 60px rgba(6, 182, 212, 0.6), 0 0 120px rgba(6, 182, 212, 0.3)'
                  }}
                >
                  {word}
                </span>
              ))}
            </div>

            {/* Feature List */}
            <div
              className={`grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-[600px] mx-auto transition-all duration-700 delay-400 ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 group"
                >
                  <span className="text-[#06b6d4] text-xl">✓</span>
                  <span className="font-harvey-sans text-white text-[15px] sm:text-[16px] font-normal tracking-wide">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
